/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const OperatorGroupRole = {
    Viewer: 'Viewer',
    Member: 'Member',
    Owner: 'Owner',
    Admin: 'Admin',
    SuperUser: 'SuperUser'
} as const;
export type OperatorGroupRole = typeof OperatorGroupRole[keyof typeof OperatorGroupRole];

